import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import nccRatings from "../../../../src/data/articles/cube-prospective-new-capenna-commander/ncc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  nccRatings,
  ProspectiveIntro,
  React
};